import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  LabelList,
  ReferenceLine,
  Cell,
} from "recharts";
import RotatedYAxisLabel from "../../../../components/Reports/RechartHelpers/RotatedYAxisLabel";
import { brightBlue } from "../../../../constants/colors";
import {
  CENTER,
  BEGINNING,
  ENDING,
  SETUP_DURATION_EXCEEDED_LIMIT,
} from "../utils/sterisChangeoverUtils";

/**
 * Used with recharts, aligns all dates in the center of the section
 *
 * @param {*} data
 * @returns
 */
export const renderCustomizedCenterTicks = props => {
  const { x, y, payload } = props;
  const { value, offset } = payload;

  const hasCenterValues =
    value.indexOf(":centerfix") !== -1 || value.indexOf(CENTER) !== -1;

  return hasCenterValues ? (
    <text
      x={
        value.indexOf(":centerfix") !== -1
          ? x - offset
          : value.indexOf(CENTER) !== -1
            ? x
            : null
      }
      y={y}
      textAnchor="middle"
      dominantBaseline="hanging"
      fill="#666"
    >
      {payload.value.split(":")[0]}
    </text>
  ) : (
    <></>
  );
};

/**
 * Used with the methods above, renders the start demarking for the date section
 *
 * @param {*} data
 * @returns
 */
export const renderCustomizedStartDemarkingTicks = props => {
  const { x, y, payload } = props;
  const { value, offset } = payload;

  return value.indexOf(BEGINNING) !== -1 ? (
    <text
      x={x - offset}
      y={y - 90}
      textAnchor="middle"
      dominantBaseline="hanging"
      fontSize="45"
      fill="#666"
    >
      {"|"}
    </text>
  ) : (
    <></>
  );
};

/**
 * Used with the methods above, renders the end demarking for the date section
 *
 * @param {*} data
 * @returns
 */
export const renderCustomizedEndDemarkingTicks = props => {
  const { x, y, payload } = props;
  const { value, offset } = payload;

  return value.indexOf(ENDING) !== -1 ? (
    <text
      x={x + offset}
      y={y - 60}
      textAnchor="middle"
      dominantBaseline="hanging"
      fontSize="45"
      fill="#666"
    >
      {"|"}
    </text>
  ) : (
    <></>
  );
};

export default function SterisChart({
  changeoverData,
  containerWidth,
  height,
  nameTicks,
  tag,
}: {
  changeoverData: any;
  containerWidth: number;
  height: number;
  nameTicks: any;
  tag: any;
}) {
  const axisLabel = tag.concat(" ", "Instance");

  return (
    <BarChart
      width={containerWidth}
      height={height}
      data={changeoverData}
      margin={{ top: 20, bottom: 5, left: 30, right: 5 }}
    >
      <XAxis dataKey="order" tickMargin={7} />
      {[
        { id: 1, tick: renderCustomizedCenterTicks },
        { id: 2, tick: renderCustomizedEndDemarkingTicks, label: true },
        { id: 3, tick: renderCustomizedStartDemarkingTicks },
      ].map(({ id, tick, label }) => {
        return (
          <XAxis
            key={id}
            dataKey="date"
            axisLine={false}
            tick={tick}
            ticks={nameTicks}
            interval={0}
            tickLine={false}
            xAxisId={id}
            label={label && axisLabel}
          />
        );
      })}
      <YAxis
        type="number"
        orientation="left"
        label={
          <RotatedYAxisLabel
            height={height - 100}
            value="Coil Change Duration (minutes)"
          />
        }
      />
      <ReferenceLine
        y={30}
        label="Target"
        stroke="black"
        strokeDasharray="3 3"
      />
      <Bar dataKey="changeoverDuration" stackId="a" fill={brightBlue} />
      <Bar dataKey="changeoverDurationExceededLim" stackId="a">
        {changeoverData.map(entry => {
          const color =
            entry.changeoverDurationExceeded > SETUP_DURATION_EXCEEDED_LIMIT
              ? "darkRed"
              : "red";
          return <Cell key={entry.total} fill={color} />;
        })}
        <LabelList dataKey="total" position="top" fill="black" />
      </Bar>
    </BarChart>
  );
}
